import React from 'react'
import PropTypes from 'prop-types'
import loadingImage from '../../../assets/buskes_loader.gif'

const PageLoadingComponent = ({ isLoading = false }) => {
  if (!isLoading) return null // Don't render at all if not loading

  return (
    <div
      className="loading-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <img
        src={loadingImage}
        alt="Loading..."
        style={{ width: '200px', height: '200px' }}
      />
    </div>
  )
}

PageLoadingComponent.propTypes = {
  isLoading: PropTypes.bool,
}

export default PageLoadingComponent
